<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Heading" });
export let size = "xl";
export let style = void 0;
export let css = "";
const TAGS = {
    lg: "h2",
    md: "h3",
    sm: "h4",
    xl: "h1",
    xs: "h5",
    xxs: "h6"
};
const TAG = TAGS[size];
</script>

{#if 'default' in $$slots}
    <svelte:element this = { TAG } class = { `s8-${ style } ${ css }` }>
        <slot>Hello World</slot>
    </svelte:element>
{/if}

<style>
    h1 {
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 20px;
        font-weight: 600;
    }

    h2 {
        font-size: 24px;
        line-height: 40px;
        margin-bottom: 20px;
        font-weight: 600;
    }

    h3 {
        font-size: 18px;
        line-height: 30px;
        margin-bottom: 10px;
        font-weight: 600;
    }

    h4 {
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 10px;
        font-weight: 600;
    }

    h5 {
        font-size: 12px;
        line-height: 20px;
        font-weight: 600;
        margin-bottom: 10px;
    }

    h6 {
        font-size: 10px;
        line-height: 15px;
        font-weight: 400;
    }

    h1:focus-visible, h2:focus-visible, h3:focus-visible, h4:focus-visible, h5:focus-visible, h6:focus-visible {
            outline: 0px !important;
        }

    h1.s8-subtle, h2.s8-subtle, h3.s8-subtle, h4.s8-subtle {
            color: rgba(39, 39, 17, 0.36);
            font-weight: 400;
        }

    h5.s8-subtle, h6.s8-subtle {
            color: rgba(39, 39, 17, 0.6);
        }</style>